import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ApiService from '../../common/services/ApiService';
import {
  PROMOTE_REFERRAL_BEGIN,
  PROMOTE_REFERRAL_SUCCESS,
  PROMOTE_REFERRAL_FAILURE,
  PROMOTE_REFERRAL_DISMISS_ERROR,
} from './constants';

export function promoteReferral(referralUUID, status, data) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PROMOTE_REFERRAL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.promoteReferral(referralUUID, status, data).then(
        (res) => {
          dispatch({
            type: PROMOTE_REFERRAL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PROMOTE_REFERRAL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissPromoteReferralError() {
  return {
    type: PROMOTE_REFERRAL_DISMISS_ERROR,
  };
}

export function usePromoteReferral() {
  const dispatch = useDispatch();

  const { promoteReferralPending, promoteReferralError } = useSelector(
    state => ({
      promoteReferralPending: state.referral.promoteReferralPending,
      promoteReferralError: state.referral.promoteReferralError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((referralUUID, args, data) => {
    return dispatch(promoteReferral(referralUUID, args, data));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissPromoteReferralError());
  }, [dispatch]);

  return {
    promoteReferral: boundAction,
    promoteReferralPending,
    promoteReferralError,
    dismissPromoteReferralError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROMOTE_REFERRAL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        promoteReferralPending: true,
        promoteReferralError: null,
      };

    case PROMOTE_REFERRAL_SUCCESS:
      // The request is success
      return {
        ...state,
        promoteReferralPending: false,
        promoteReferralError: null,
      };

    case PROMOTE_REFERRAL_FAILURE:
      // The request is failed
      return {
        ...state,
        promoteReferralPending: false,
        promoteReferralError: action.data.error,
      };

    case PROMOTE_REFERRAL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        promoteReferralError: null,
      };

    default:
      return state;
  }
}
